import {
	Button,
	Card,
	Filters,
	ResourceItem,
	ResourceList,
	TextStyle,
	Thumbnail,
} from "@shopify/polaris"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const FailedUploadsList = (props) => {
	const [products, setProducts] = useState([])
	const [filteredProducts, setFilteredProducts] = useState([])
	const [selectedItems, setSelectedItems] = useState([])
	const [query, setQuery] = useState("")
	const { t } = useTranslation()

	useEffect(() => {
		setProducts(props.failedUploads)
		setFilteredProducts(props.failedUploads)
	}, [props.failedUploads])

	const renderProduct = (product) => {
		const media = (
			<Thumbnail size="large" source={product?.images?.[0]?.src || ""} />
		)

		return (
			<ResourceItem id={product.id || ""} media={media}>
				<h3>
					<TextStyle variation="strong">
						{product.title || ""}
					</TextStyle>
				</h3>
				<div style={{ color: "red" }}>{product.error}</div>
			</ResourceItem>
		)
	}

	const updateSelected = (e) => {
		setSelectedItems(e)
	}

	const onQueryChange = (change) => {
		setQuery(change)

		if (products.length > 0) {
			const value = change
			let updatedData = []

			if (value.length) {
				updatedData = products.filter((item) => {
					if (!item?.title) return false

					const startsWith = item.title
						.toLowerCase()
						.startsWith(value.toLowerCase())

					const includes = item.title
						.toLowerCase()
						.includes(value.toLowerCase())

					if (startsWith) {
						return startsWith
					} else if (!startsWith && includes) {
						return includes
					} else {
						return false
					}
				})
				setFilteredProducts(updatedData)
			} else {
				setFilteredProducts(products)
			}
		}
	}

	return (
		<>
			<Card>
				<ResourceList
					resourceName={{
						singular: "product",
						plural: "products",
					}}
					items={filteredProducts}
					renderItem={renderProduct}
					selectedItems={selectedItems}
					onSelectionChange={updateSelected}
					selectable
					filterControl={
						<Filters
							filters={[]}
							queryValue={query}
							onQueryChange={onQueryChange}
							onQueryClear={() => {
								setQuery("")
								setFilteredProducts(products)
							}}
						/>
					}
					alternateTool={
						<Button onClick={() => props.retryUpload(products)}>
							{t("multiple.retry_all")}
						</Button>
					}
					promotedBulkActions={[
						{
							content: t("multiple.retry_uploading_selected"),
							disabled: props.uploadingSubmittedProducts,
							onAction: () =>
								props.retryUpload(
									products.filter((p) =>
										selectedItems.includes(p.id),
									),
								),
						},
					]}
				/>
			</Card>
		</>
	)
}

export default FailedUploadsList
